<template lang="pug">
  modal(
    :title='$t("trialInvite.title")'
    @closeModal='hideElement({ element: "trialInviteModal" })'
    @inputState='updateInputState'
  )
    .column
      .column.m4-bottom-6
        h2.text-big.dark-gray.m-top-1.m4-bottom-12(v-html='$t("trial.inviteFourColleagues")')
        invite-input.m4-bottom-5(
          v-for='(email, index) in emailsWithState'
          :inputIndex='index'
          :type='email.state'
          :propEmail='email.email'
          :key='`${email.email}-${index}`'
        )
      .row.end
        button.secondary-button.m4-right-4(type='button' @click='closeModal')
          | {{ $t('trialInvite.cancelButton') }}
        button.primary-button(type='button' @click='sendInvitations' :disabled='blockSendButton')
          | {{ $t('trialInvite.sendButton') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import amplitude from 'amplitude-js'

import Modal from '@/components/Modal'
import InviteInput from './InviteInput'

export default {
  components: { Modal, InviteInput },
  data() {
    return {
      inputErrors: [false, false, false, false],
      blockSendButton: true
    }
  },
  computed: {
    ...mapState({
      emailsToInvite: state => state.trial.emailsToInvite,
      emailsWithState: state => state.trial.emailsWithState
    })
  },
  mounted() {
    this.loadInvitedUsers()
  },
  methods: {
    ...mapActions(['hideElement', 'getInvitedUsers', 'sendTrialInvitations']),
    closeModal() {
      this.hideElement({ element: 'trialInviteModal' })
    },
    loadInvitedUsers() {
      this.getInvitedUsers()
    },
    updateInputState(state, index) {
      this.inputErrors[index] = state
      this.blockSendButton = this.inputErrors.some(error => error)
    },
    sendInvitations() {
      amplitude.getInstance().logEvent('Trial Invitation', { amountOfInvitations: this.emailsToInvite.length })
      this.sendTrialInvitations()
    }
  }
}
</script>
